import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { OptionsService } from '../services/options.service'
import { setSlowGasLeakOptions } from '../store/options.actions'

export function* getSlowGasLeakOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const slowGasLeakOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getSlowGasLeakOptions,
    ])
    const { entity } = slowGasLeakOptionsResponse
    if (entity) yield put(setSlowGasLeakOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getSlowGasLeakOptions() error: ${e}`))
  }
}

export function* getSlowGasLeakOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getSlowGasLeakOptions)
}
